export let OrdersDetailModalFieldsJSON = {
  "1718617002793-customSelect": {
    elementid: 1718617002793,
    elementtype: "customSelect",
    "data-datasource": "customvalues",
    "data-customvalue": [],
    "database-label": "product_id",
    "display-fieldlabel": "Product",
    "display-placeholder": "Enter",
    "display-noofcolumns": "2",
    "display-labelposition": "top",
    "display-placeholder": "Select",
    "display-required": 1,
  },

  "1718616994627-customSelect": {
    elementid: 1718616994627,
    elementtype: "customSelect",
    "data-datasource": "customvalues",
    "data-customvalue": "SINGLE#CLUBBED",
    "database-label": "product_type",
    "display-fieldlabel": "Product Type",
    "display-placeholder": "Enter",
    "display-noofcolumns": "2",
    "display-labelposition": "top",
    "display-placeholder": "Select",
    "display-required": 1,
  },
  "1718617024542-customSelect": {
    elementid: 1718617024542,
    elementtype: "customSelect",
    "data-datasource": "customvalues",
    "data-customvalue": "FRESH",
    "database-label": "order_type",
    "display-fieldlabel": "Order Type",
    "display-placeholder": "Select",
    "display-noofcolumns": "2",
    "display-labelposition": "top",
    "display-required": 1,
  },
  "1718616922481-columns": {
    elementid: 1718616922481,
    elementtype: "columns",
    "display-fieldlabel": "Columns",
    "display-noofcolumns": "2",
  },
  "1718616936763-columns": {
    elementid: 1718616936763,
    elementtype: "columns",
    "display-fieldlabel": "Columns",
    "display-noofcolumns": "2",
  },
  "1718616939763-columns": {
    elementid: 1718616939763,
    elementtype: "columns",
    "display-fieldlabel": "Columns",
    "display-noofcolumns": "2",
  },
  "1718616942462-columns": {
    elementid: 1718616942462,
    elementtype: "columns",
    "display-fieldlabel": "Columns",
    "display-noofcolumns": "2",
  },
  "1718616955479-columns": {
    elementid: 1718616955479,
    elementtype: "columns",
    "display-fieldlabel": "Columns",
    "display-noofcolumns": "2",
  },
  "1718616961228-columns": {
    elementid: 1718616961228,
    elementtype: "columns",
    "display-fieldlabel": "Columns",
    "display-noofcolumns": "2",
  },
  "1718616967444-textfield": {
    elementid: 1718616967444,
    elementtype: "textfield",
    "display-fieldlabel": "Order Id",
    "database-label": "code",
    "validation-maxlength": "2000",
    "validation-minlength": "0",
    "display-labelposition": "top",
    // "display-placeholder": "Enter",
    "display-disabled": 1,
  },
  "1718616970411-customDate": {
    elementid: 1718616970411,
    elementtype: "customDate",
    "display-required": 1,
    "database-label": "created_date",
    "display-fieldlabel": "Order Date",
    "display-labelposition": "top",
    "display-placeholder": "date",
    "display-current": 1,
    "display-disabled": 1,
  },
  "1718616976561-customSelect": {
    elementid: 1718616976561,
    elementtype: "customSelect",
    "data-datasource": "customvalues",
    "data-customvalue": [],
    "database-label": "customer_id",
    "display-fieldlabel": "Customer",
    "display-placeholder": "Enter",
    "display-noofcolumns": "2",
    "display-labelposition": "top",
    "display-placeholder": "Select",
    "display-required": 1,
  },
  "1718617011709-number": {
    elementid: 1718617011709,
    elementtype: "number",
    "display-fieldlabel": "Product Price",
    "database-label": "gross_amount",
    "validation-maxlength": "2000",
    "validation-minlength": "0",
    "display-labelposition": "top",
    // "display-placeholder": "Enter",
    "display-disabled": 1,
  },
  "1718617014275-number": {
    elementid: 1718617014275,
    elementtype: "number",
    "display-fieldlabel": "Amount Paid",
    "database-label": "amount_paid",
    "validation-maxlength": "2000",
    "validation-minlength": "0",
    "display-labelposition": "top",
    // "display-placeholder": "Enter",
    "display-disabled": 1,
  },
  "1718617031258-customSelect": {
    elementid: 1718617031258,
    elementtype: "customSelect",
    "data-datasource": "customvalues",
    "data-customvalue":
      "PAYMENT-SUCCESS#PAYMENT-PENDING#PROPOSAL-PENDING#PAYMENT-FAILED#CANCELLED",
    "database-label": "status",
    "display-fieldlabel": "Status",
    "display-placeholder": "Select",
    "display-noofcolumns": "2",
    "display-labelposition": "top",
    "display-required": 1,
    "display-disabled": 1,
  },
  // "1718617038957-customSelect": {
  //   elementid: 1718617038957,
  //   elementtype: "customSelect",
  //   "data-datasource": "customvalues",
  //   "data-customvalue": [],
  //   "database-label": "rm_name",
  //   "display-fieldlabel": "Relationship Manager",
  //   "display-placeholder": "Enter",
  //   "display-noofcolumns": "2",
  //   "display-labelposition": "top",
  //   // "display-required": 1,
  // },
  "1718616984561-customSelect": {
    elementid: 1718616984561,
    elementtype: "customSelect",
    "data-datasource": "customvalues",
    "data-customvalue": [],
    "database-label": "ag_id",
    "display-fieldlabel": "AG",
    "display-placeholder": "Enter",
    "display-placeholder": "Select",
    "display-noofcolumns": "2",
    "display-labelposition": "top",
    "display-required": 1,
  },
};

export const useOrderStatusEnableCondition = () => {
  const detailsData = useSelector(
    (state) => state.order.selectedOrders.detailsData
  );

  return detailsData?.status === "PAYMENT_PENDING";
};

export let OrdersEditDetailModalFieldsJSON = {
  "1718617002793-textfield": {
    elementid: 1718617002793,
    elementtype: "textfield",
    "display-required": 1,
    "database-label": "name",
    "display-fieldlabel": "Product",
    "display-labelposition": "top",
    "display-placeholder": "status",
    "display-disabled": 1,
  },
  "1718616994627-textfield": {
    elementid: 1718616994627,
    elementtype: "textfield",
    "data-datasource": "customvalues",
    "data-customvalue": "a#b",
    "database-label": "product_type",
    "display-fieldlabel": "Product Type",
    "display-noofcolumns": "2",
    "display-labelposition": "top",
    "display-disabled": 1,
  },
  "1718617024542-textfield": {
    elementid: 1718617024542,
    elementtype: "textfield",
    "display-fieldlabel": "Order Type ",
    "database-label": "order_type",
    "display-labelposition": "top",
    "display-placeholder": "Enter",
    "display-disabled": 1,
  },
  "1718616922481-columns": {
    elementid: 1718616922481,
    elementtype: "columns",
    "display-fieldlabel": "Columns",
    "display-noofcolumns": "2",
  },
  "1718616936763-columns": {
    elementid: 1718616936763,
    elementtype: "columns",
    "display-fieldlabel": "Columns",
    "display-noofcolumns": "2",
  },
  "1718616939763-columns": {
    elementid: 1718616939763,
    elementtype: "columns",
    "display-fieldlabel": "Columns",
    "display-noofcolumns": "2",
  },
  "1718616942462-columns": {
    elementid: 1718616942462,
    elementtype: "columns",
    "display-fieldlabel": "Columns",
    "display-noofcolumns": "2",
  },
  "1718616955479-columns": {
    elementid: 1718616955479,
    elementtype: "columns",
    "display-fieldlabel": "Columns",
    "display-noofcolumns": "2",
  },
  "1718616961228-columns": {
    elementid: 1718616961228,
    elementtype: "columns",
    "display-fieldlabel": "Columns",
    "display-noofcolumns": "2",
  },
  "1718616967444-textfield": {
    elementid: 1718616967444,
    elementtype: "textfield",
    "display-required": 1,
    "display-fieldlabel": "Order Id",
    "database-label": "code",
    "validation-maxlength": "2000",
    "validation-minlength": "0",
    "display-labelposition": "top",
    "display-placeholder": "Enter",
    "validation-pattern": "^[a-zA-Z0-9._\\-\\s]*",
    "display-disabled": 1,
  },
  //   "1718616970411-textfield": {
  //     elementid: 1718616970411,
  //     elementtype: "textfield",
  //     "display-required": 1,
  //     "display-fieldlabel": "Last Name",
  //     "database-label": "last_name",
  //     "validation-maxlength": "2000",
  //     "validation-minlength": "0",
  //     "display-labelposition": "top",
  //     "display-placeholder": "Enter",
  //     "validation-pattern": "^[a-zA-Z0-9._\\-\\s]*",
  //   },
  "1718616970411-customDate": {
    elementid: 1718616970411,
    elementtype: "customDate",
    "display-required": 1,
    "database-label": "created_date",
    "display-fieldlabel": "Order Date",
    "display-labelposition": "top",
    "display-placeholder": "date",
    "display-disabled": 1,
  },
  "1718616976561-textfield": {
    elementid: 1718616976561,
    elementtype: "textfield",
    "data-datasource": "customvalues",
    // "data-customvalue": "MALE#FEMALE",
    "database-label": "ag_name",
    "display-fieldlabel": "AG",
    "display-placeholder": "Enter",
    "display-noofcolumns": "2",
    "display-labelposition": "top",
    "display-disabled": 1,
  },
  "1718617011709-textfield": {
    elementid: 1718617011709,
    elementtype: "textfield",
    "display-fieldlabel": "Product Price",
    "database-label": "gross_amount",
    "validation-maxlength": "2000",
    "validation-minlength": "0",
    "display-labelposition": "top",
    "display-placeholder": "Enter",
    "display-disabled": 1,
  },
  "1718617014275-textfield": {
    elementid: 1718617014275,
    elementtype: "textfield",
    "display-fieldlabel": "Amount Paid",
    "database-label": "gross_amount",
    "validation-maxlength": "2000",
    "validation-minlength": "0",
    "display-labelposition": "top",
    "display-placeholder": "Enter",
    "display-disabled": 1,
  },
  // "1718617031258-customSelect": {
  //   elementid: 1718617031258,
  //   elementtype: "customSelect",
  //   "display-fieldlabel": "Relationship Manager",
  //   "database-label": "emp_code",
  //   "validation-maxlength": "2000",
  //   "validation-minlength": "0",
  //   "display-labelposition": "top",
  //   "display-placeholder": "Enter",
  //   "display-disabled": 1,
  // },
  "1718617031258-customSelect": {
    elementid: 1718617031258,
    elementtype: "customSelect",
    "data-customvalue":
      "PAYMENT_SUCCESS#PAYMENT_PENDING#PAYMENT_FAILED#CANCELLED#COMPLETED",
    "display-fieldlabel": "Status",
    "display-placeholder": "Select",
    "database-label": "status",
    "display-labelposition": "top",
    "display-placeholder": "Enter",
    // "display-disabled": 1,
  },
  "1718617038957-textfield": {
    elementid: 1718617038957,
    elementtype: "textfield",
    "display-fieldlabel": "Relationship Manager",
    "database-label": "rm_name",
    "validation-maxlength": "2000",
    "validation-minlength": "0",
    "display-labelposition": "top",
    "display-placeholder": "Enter",
    "display-disabled": 1,
  },
  // "1718616984561-textfield": {
  //   elementid: 1718616984561,
  //   elementtype: "textfield",
  //   "display-fieldlabel": "Customer",
  //   "database-label": "customer_name",
  //   "display-labelposition": "top",
  //   "display-placeholder": "Enter",
  //   "validation-maxlength": "10",
  //   "validation-pattern": "^[0-9+\\-\\s()]*$",
  //   "display-disabled": 1,
  // },
  "1718616984561-customSelect": {
    elementid: 1718616984561,
    elementtype: "customSelect",
    "data-datasource": "customvalues",
    "data-customvalue": [],
    "database-label": "customer_id",
    "display-fieldlabel": "Customer",
    "display-placeholder": "Enter",
    "display-noofcolumns": "2",
    "display-labelposition": "top",
    "display-placeholder": "Select",
    "enable-condition": useOrderStatusEnableCondition,
  },

  // new fields for renewal start

  "1718617038952-textfield": {
    elementid: 1718617038952,
    elementtype: "textfield",
    "display-fieldlabel": "Prev Order Id",
    "database-label": "prev_order_id",
    "display-labelposition": "top",
    "display-disabled": 1,
    "display-yes": "order_type",
  },
  "1718617038958-textfield": {
    elementid: 1718617038958,
    elementtype: "textfield",
    "display-fieldlabel": "Parent Order Id",
    "database-label": "parent_order_id",
    "display-labelposition": "top",
    "display-placeholder": "Enter",
    "display-disabled": 1,
    "display-yes": "order_type",
  },
  "1718616970419-customDate": {
    elementid: 1718616970419,
    elementtype: "customDate",
    "display-required": 1,
    "database-label": "renewal_due_on",
    "display-fieldlabel": "Renewal Due On",
    "display-labelposition": "top",
    "display-placeholder": "date",
    "display-disabled": 1,
    "display-yes": "order_type",
  },
  "1718617038989-textfield": {
    elementid: 1718617038989,
    elementtype: "textfield",
    "display-fieldlabel": "Renewal Category",
    "database-label": "renewal_category",
    "display-labelposition": "top",
    "display-placeholder": "Enter",
    "display-disabled": 1,
    "display-yes": "order_type",
  },
  "1718617038959-textfield": {
    elementid: 1718617038959,
    elementtype: "textfield",
    "display-fieldlabel": "Renewal Status",
    "database-label": "renewal_status",
    "display-labelposition": "top",
    "display-placeholder": "Enter",
    "display-disabled": 1,
    "display-yes": "order_type",
  },

  "1718617038951-textfield": {
    elementid: 1718617038951,
    elementtype: "textfield",
    "display-fieldlabel": "Previous Policy Insurer",
    "database-label": "previous_policy_insurer",
    "display-labelposition": "top",
    "display-placeholder": "Enter",
    "display-disabled": 1,
    "display-yes": "order_type",
  },
  "1718617038962-textfield": {
    elementid: 1718617038962,
    elementtype: "textfield",
    "display-fieldlabel": "Previous Policy Premium",
    "database-label": "previous_policy_premium",
    "display-labelposition": "top",
    "display-placeholder": "Enter",
    "display-disabled": 1,
    "display-yes": "order_type",
  },
  "1718617038953-textfield": {
    elementid: 1718617038953,
    elementtype: "textfield",
    "display-fieldlabel": "Previous Policy Coverage",
    "database-label": "previous_policy_coverage",
    "display-labelposition": "top",
    "display-placeholder": "Enter",
    "display-disabled": 1,
    "display-yes": "order_type",
  },
  "1718617038954-textfield": {
    elementid: 1718617038954,
    elementtype: "textfield",
    "display-fieldlabel": "Previous Policy Number",
    "database-label": "previous_policy_number",
    "display-labelposition": "top",
    "display-placeholder": "Enter",
    "display-disabled": 1,
    "display-yes": "order_type",
  },
  "1718617035555-textfield": {
    elementid: 1718617035555,
    elementtype: "textfield",
    "display-fieldlabel": "Proposal Filled",
    "database-label": "proposal_filled",
    "display-labelposition": "top",
    "display-placeholder": "Enter",
    "display-disabled": 1,
  },
  "1718617035556-textfield": {
    elementid: 1718617035556,
    elementtype: "textfield",
    "display-fieldlabel": "KYC Status",
    "database-label": "kyc_status",
    "display-labelposition": "top",
    "display-placeholder": "Enter",
    "display-disabled": 1,
    "default-value": "KYC Verification Pending",
  },
};

// renewal end

export let BillingDetailsModalFieldsJSON = {
  "1718616976561-email": {
    elementid: 1718617002793,
    elementtype: "email",
    "display-required": 1,
    "display-fieldlabel": "Email id",
    "database-label": "billing_email",
    "validation-maxlength": "2000",
    "validation-minlength": "0",
    "display-labelposition": "top",
    "display-placeholder": "Enter",
    "validation-pattern": "^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,}$",
  },
  "1718616994627-phoneNumber": {
    elementid: 1718616994627,
    elementtype: "phoneNumber",
    "display-fieldlabel": "Mobile No.",
    "display-required": 1,
    "database-label": "billing_contact",
    "display-labelposition": "top",
    "display-placeholder": "Enter",
    "validation-maxlength": "10",
    "validation-pattern": "^[0-9+\\-\\s()]*$",
  },
  "1718617024542-number": {
    elementid: 1718617024542,
    elementtype: "number",
    "display-fieldlabel": "Pincode ",
    "database-label": "pincode",
    "display-labelposition": "top",
    "display-placeholder": "Enter",
  },
  "1718616922481-columns": {
    elementid: 1718616922481,
    elementtype: "columns",
    "display-fieldlabel": "Columns",
    "display-noofcolumns": "2",
  },
  "1718616936763-columns": {
    elementid: 1718616936763,
    elementtype: "columns",
    "display-fieldlabel": "Columns",
    "display-noofcolumns": "2",
  },
  "1718616939763-columns": {
    elementid: 1718616939763,
    elementtype: "columns",
    "display-fieldlabel": "Columns",
    "display-noofcolumns": "2",
  },
  "1718616942462-columns": {
    elementid: 1718616942462,
    elementtype: "columns",
    "display-fieldlabel": "Columns",
    "display-noofcolumns": "2",
  },
  "1718616955479-columns": {
    elementid: 1718616955479,
    elementtype: "columns",
    "display-fieldlabel": "Columns",
    "display-noofcolumns": "2",
  },
  "1718616961228-columns": {
    elementid: 1718616961228,
    elementtype: "columns",
    "display-fieldlabel": "Columns",
    "display-noofcolumns": "2",
  },
  // "1718616967444-textfield": {
  //   elementid: 1718616967444,
  //   elementtype: "textfield",
  //   "display-required": 1,
  //   "display-fieldlabel": "For",
  //   "database-label": "for",
  //   "validation-maxlength": "2000",
  //   "validation-minlength": "0",
  //   "display-labelposition": "top",
  //   "display-placeholder": "Enter",
  //   "validation-pattern": "^[a-zA-Z0-9._\\-\\s]*",
  // },
  "1718616970411-textfield": {
    elementid: 1718616970411,
    elementtype: "textfield",
    "display-required": 1,
    "display-fieldlabel": "Last Name",
    "database-label": "billing_last_name",
    "validation-maxlength": "2000",
    "validation-minlength": "0",
    "display-labelposition": "top",
    "display-placeholder": "Enter",
    "validation-pattern": "^[a-zA-Z0-9._\\-\\s]*",
  },
  "1718616976561-textfield": {
    elementid: 1718616976561,
    elementtype: "textfield",
    "display-required": 1,
    "display-fieldlabel": "First Name",
    "database-label": "billing_first_name",
    "validation-maxlength": "2000",
    "validation-minlength": "0",
    "display-labelposition": "top",
    "display-placeholder": "Enter",
    "validation-pattern": "^[a-zA-Z0-9._\\-\\s]*",
  },
  "1718617011709-textfield": {
    elementid: 1718617011709,
    elementtype: "textfield",
    "display-fieldlabel": "Address line 1",
    "database-label": "billing_address",
    "validation-maxlength": "2000",
    "validation-minlength": "0",
    "display-labelposition": "top",
    "display-placeholder": "Enter",
  },
  "1718617014275-textfield": {
    elementid: 1718617014275,
    elementtype: "textfield",
    "display-fieldlabel": "Address line 2",
    "database-label": "address2",
    "validation-maxlength": "2000",
    "validation-minlength": "0",
    "display-labelposition": "top",
    "display-placeholder": "Enter",
  },
  "1718617031258-textfield": {
    elementid: 1718617031258,
    elementtype: "textfield",
    "display-fieldlabel": "Customer Code",
    "database-label": "emp_code",
    "validation-maxlength": "2000",
    "validation-minlength": "0",
    "display-labelposition": "top",
    "display-placeholder": "Enter",
  },
  "1718617038957-textfield": {
    elementid: 1718617038957,
    elementtype: "textfield",
    "display-fieldlabel": "State",
    "database-label": "state",
    "validation-maxlength": "2000",
    "validation-minlength": "0",
    "display-labelposition": "top",
    "display-placeholder": "Enter",
  },
  "1718617041258-textfield": {
    elementid: 1718617041258,
    elementtype: "textfield",
    "display-fieldlabel": "City",
    "database-label": "city",
    "validation-maxlength": "2000",
    "validation-minlength": "0",
    "display-labelposition": "top",
    "display-placeholder": "Enter",
  },
  "1718616984561-textfield": {
    elementid: 1718616984561,
    elementtype: "textfield",
    "display-required": 1,
    "display-fieldlabel": "Last Name",
    "database-label": "last_name",
    "validation-maxlength": "2000",
    "validation-minlength": "0",
    "display-labelposition": "top",
    "display-placeholder": "Enter",
    "validation-pattern": "^[a-zA-Z0-9._\\-\\s]*",
  },
};

export let BillingEditDetailsModalFieldsJSON = {
  "1718616976561-email": {
    elementid: 1718617002793,
    elementtype: "email",
    "display-required": 1,
    "display-fieldlabel": "Email id",
    "database-label": "billing_email",
    "validation-maxlength": "2000",
    "validation-minlength": "0",
    "display-labelposition": "top",
    "display-placeholder": "Enter",
    "validation-pattern": "^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,}$",
  },
  "1718616994627-phoneNumber": {
    elementid: 1718616994627,
    elementtype: "phoneNumber",
    "display-fieldlabel": "Mobile No.",
    "database-label": "billing_contact",
    "display-labelposition": "top",
    "display-placeholder": "Enter",
    "validation-maxlength": "10",
    "validation-pattern": "^[0-9+\\-\\s()]*$",
  },
  "1718617024542-number": {
    elementid: 1718617024542,
    elementtype: "number",
    "display-fieldlabel": "Pincode ",
    "database-label": "pincode",
    "display-labelposition": "top",
    "display-placeholder": "Enter",
  },
  "1718616922481-columns": {
    elementid: 1718616922481,
    elementtype: "columns",
    "display-fieldlabel": "Columns",
    "display-noofcolumns": "2",
  },
  "1718616936763-columns": {
    elementid: 1718616936763,
    elementtype: "columns",
    "display-fieldlabel": "Columns",
    "display-noofcolumns": "2",
  },
  "1718616939763-columns": {
    elementid: 1718616939763,
    elementtype: "columns",
    "display-fieldlabel": "Columns",
    "display-noofcolumns": "2",
  },
  "1718616942462-columns": {
    elementid: 1718616942462,
    elementtype: "columns",
    "display-fieldlabel": "Columns",
    "display-noofcolumns": "2",
  },
  "1718616955479-columns": {
    elementid: 1718616955479,
    elementtype: "columns",
    "display-fieldlabel": "Columns",
    "display-noofcolumns": "2",
  },
  "1718616961228-columns": {
    elementid: 1718616961228,
    elementtype: "columns",
    "display-fieldlabel": "Columns",
    "display-noofcolumns": "2",
  },

  "1718616970411-textfield": {
    elementid: 1718616970411,
    elementtype: "textfield",
    "display-required": 1,
    "display-fieldlabel": "Last Name",
    "database-label": "billing_last_name",
    "validation-maxlength": "2000",
    "validation-minlength": "0",
    "display-labelposition": "top",
    "display-placeholder": "Enter",
    "validation-pattern": "^[a-zA-Z0-9._\\-\\s]*",
  },
  "1718616976561-textfield": {
    elementid: 1718616976561,
    elementtype: "textfield",
    "display-required": 1,
    "display-fieldlabel": "First Name",
    "database-label": "billing_first_name",
    "validation-maxlength": "2000",
    "validation-minlength": "0",
    "display-labelposition": "top",
    "display-placeholder": "Enter",
    "validation-pattern": "^[a-zA-Z0-9._\\-\\s]*",
  },
  "1718617011709-textfield": {
    elementid: 1718617011709,
    elementtype: "textfield",
    "display-fieldlabel": "Address line 1",
    "database-label": "address",
    "validation-maxlength": "2000",
    "validation-minlength": "0",
    "display-labelposition": "top",
    "display-placeholder": "Enter",
  },
  "1718617014275-textfield": {
    elementid: 1718617014275,
    elementtype: "textfield",
    "display-fieldlabel": "Address line 2",
    "database-label": "address2",
    "validation-maxlength": "2000",
    "validation-minlength": "0",
    "display-labelposition": "top",
    "display-placeholder": "Enter",
  },
  "1718617031258-textfield": {
    elementid: 1718617031258,
    elementtype: "textfield",
    "display-fieldlabel": "Customer Code",
    "database-label": "emp_code",
    "validation-maxlength": "2000",
    "validation-minlength": "0",
    "display-labelposition": "top",
    "display-placeholder": "Enter",
  },
  "1718617038957-textfield": {
    elementid: 1718617038957,
    elementtype: "textfield",
    "display-fieldlabel": "State",
    "database-label": "state",
    "validation-maxlength": "2000",
    "validation-minlength": "0",
    "display-labelposition": "top",
    "display-placeholder": "Enter",
  },
  "1718617041258-textfield": {
    elementid: 1718617041258,
    elementtype: "textfield",
    "display-fieldlabel": "City",
    "database-label": "city",
    "validation-maxlength": "2000",
    "validation-minlength": "0",
    "display-labelposition": "top",
    "display-placeholder": "Enter",
  },
  "1718616984561-textfield": {
    elementid: 1718616984561,
    elementtype: "textfield",
    "display-required": 1,
    "display-fieldlabel": "Last Name",
    "database-label": "last_name",
    "validation-maxlength": "2000",
    "validation-minlength": "0",
    "display-labelposition": "top",
    "display-placeholder": "Enter",
    "validation-pattern": "^[a-zA-Z0-9._\\-\\s]*",
  },
};

export const DocumentsFieldsJSON = {
  "1720177249476-documentFile": {
    elementid: 1720177249476,
    elementtype: "documentFile",
    "display-fieldlabel": "Invoice",
    "display-labelposition": "top",
    "database-label": "invoice_media_id",
    // "database-label": "logo",
    // "display-required": 1,
    // "validation-filepattern": ".jpeg,.jpg,.png,.webp,.svg,.gif",
  },
  "1720177264442-documentFile": {
    elementid: 1720177264442,
    elementtype: "documentFile",
    "display-fieldlabel": "Certificate",
    "display-labelposition": "top",
    "database-label": "certificate_media_id",
    // "display-required": 1,
    // "validation-filepattern": ".jpeg,.jpg,.png,.webp,.svg,.gif",
  },
};

// export const PolicyModalFieldsJSON = {
//   "1717412387761-email": {
//     elementid: 1717412387761,
//     elementtype: "email",
//     "display-required": 1,
//     "display-fieldlabel": "Email",
//     "database-label": "pri_contact_email",
//     "display-placeholder": "Enter",
//     "validation-maxlength": "2000",
//     "validation-minlength": "0",
//     "display-labelposition": "top",
//     "validation-pattern": "^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,}$",
//   },
//   "1717412308306-textfield": {
//     elementid: 1717412308306,
//     elementtype: "textfield",
//     "display-fieldlabel": "Status",
//     "display-required": 1,
//     "database-label": "status",
//     "display-placeholder": "Enter",
//     "validation-maxlength": "2000",
//     "validation-minlength": "0",
//     "display-labelposition": "top",
//     // "validation-pattern": "^[a-zA-Z0-9._\\-\\s]*",
//   },
//   "1717412315194-customSelect": {
//     elementid: 1717412315194,
//     elementtype: "customSelect",
//     "display-required": 1,
//     "database-label": "status",
//     "data-datasource": "customvalues",
//     "data-customvalue": "ACTIVE#INACTIVE",
//     "display-fieldlabel": "Insurer",
//     "display-noofcolumns": "2",
//     "display-labelposition": "top",
//   },
//   "1717412405877-phoneNumber": {
//     elementid: 1717412405877,
//     elementtype: "phoneNumber",
//     "display-fieldlabel": "Contact Number",
//     "database-label": "pri_contact_number",
//     "display-placeholder": "Enter",
//     "display-labelposition": "top",
//     "validation-maxlength": "10",
//     "validation-pattern": "^[0-9+\\-\\s()]*$",
//   },
//   "1717412292824-columns": {
//     elementid: 1717412292824,
//     elementtype: "columns",
//     "display-fieldlabel": "Columns",
//     "display-noofcolumns": "2",
//   },
//   "1717412297658-columns": {
//     elementid: 1717412297658,
//     elementtype: "columns",
//     "display-fieldlabel": "Columns",
//     "display-noofcolumns": "2",
//   },
//   "1717412338444-columns": {
//     elementid: 1717412338444,
//     elementtype: "columns",
//     "display-fieldlabel": "Columns",
//     "display-noofcolumns": "2",
//   },
//   "1717412346075-columns": {
//     elementid: 1717412346075,
//     elementtype: "columns",
//     "display-fieldlabel": "Columns",
//     "display-noofcolumns": "2",
//   },
//   "1717412351926-columns": {
//     elementid: 1717412351926,
//     elementtype: "columns",
//     "display-fieldlabel": "Columns",
//     "display-noofcolumns": "2",
//   },
//   "1717412274041-fieldset": {
//     elementid: 1717412274041,
//     elementtype: "fieldset",
//     "display-legend": "Company Details",
//     "display-fieldlabel": "Field Set",
//   },
//   "1717412322677-fieldset": {
//     elementid: 1717412322677,
//     elementtype: "fieldset",
//     "display-legend": "Primary Contact",
//     "display-fieldlabel": "Field Set",
//   },
//   "1717412302140-textfield": {
//     elementid: 1717412302140,
//     elementtype: "textfield",
//     "display-fieldlabel": "Policy Number",
//     "display-required": 1,
//     "database-label": "name",
//     "display-placeholder": "Enter",
//     "validation-maxlength": "2000",
//     "validation-minlength": "0",
//     "display-labelposition": "top",
//     "validation-pattern": "^[a-zA-Z0-9._\\-\\s]*",
//   },
//   "1717412375477-textfield": {
//     elementid: 1717412375477,
//     elementtype: "textfield",
//     "display-required": 1,
//     "display-fieldlabel": "Name",
//     "database-label": "pri_contact_name",
//     "display-placeholder": "Enter",
//     "validation-maxlength": "2000",
//     "validation-minlength": "0",
//     "display-labelposition": "top",
//     "validation-pattern": "^[a-zA-Z0-9._\\-\\s]*",
//   },
//   "1717412412343-textfield": {
//     elementid: 1717412412343,
//     elementtype: "textfield",
//     "display-fieldlabel": "Department",
//     "database-label": "pri_contact_designation",
//     "display-placeholder": "Enter",
//     "validation-maxlength": "2000",
//     "validation-minlength": "0",
//     "display-labelposition": "top",
//   },
//   "1717412415059-textfield": {
//     elementid: 1717412415059,
//     elementtype: "textfield",
//     "display-fieldlabel": "Designation",
//     "display-placeholder": "Enter",
//     "validation-maxlength": "2000",
//     "validation-minlength": "0",
//     "display-labelposition": "top",
//   },
// };



export const PolicyModalFieldsJSON = {
  "1717412308306-textfield": {
    elementid: 1717412308306,
    elementtype: "textfield",
    "display-fieldlabel": "Policy Number",
    "display-required": 1,
    "database-label": "policy_no",
    "display-placeholder": "Enter Policy Number",
    "validation-maxlength": "100",
    "validation-minlength": "1",
    "display-labelposition": "top",
    // "display-disabled": 1,
  },
  // "1717412315194-customSelect": {
  //   elementid: 1717412315194,
  //   elementtype: "customSelect",
  //   "display-fieldlabel": "Status",
  //   // "display-required": 1,
  //   "database-label": "status",
  //   "data-datasource": "customvalues",
  //   "data-customvalue": "AWAITED_UNDERWRITING#DETAILS_AWAITED#REJECTED#ISSUED",
  //   "display-labelposition": "top",
  // },
  "1717412315194-customSelect": {
    elementid: 1717412315194,
    elementtype: "customSelect",
    "display-required": 1,
    "database-label": "status",
    "data-datasource": "customvalues",
    "data-customvalue": "AWAITED_UNDERWRITING#DETAILS_AWAITED#REJECTED#ISSUED",
    "display-fieldlabel": "Status",
    "display-noofcolumns": "2",
    "display-labelposition": "top",
    "display-placeholder": "Select",
  },
  // "1717412405877-customSelect": {
  //   elementid: 1717412405877,
  //   elementtype: "customSelect",
  //   "display-fieldlabel": "Insurer",
  //   // "display-required": 1,
  //   "database-label": "oem_name",
  //   "data-datasource": "api",
  //   "display-placeholder": "Select Insurer",
  //   "display-labelposition": "top",
  //   "display-disabled": 1,
  // },
  "1717412405877-textfield": {
    elementid: 1717412405877,
    elementtype: "textfield",
    "display-fieldlabel": "Insurer",
    // "display-required": 1,
    "database-label": "oem_name",
    "display-placeholder": "Enterr",
    // "validation-maxlength": "100",
    // "validation-minlength": "1",
    "display-labelposition": "top",
    "display-disabled": 1,
  },
  "1717412415059-textfield": {
    elementid: 1717412415059,
    elementtype: "textfield",
    "display-fieldlabel": "Policy Holder Name",
    // "display-required": 1,
    "database-label": "policy_holder_name",
    "display-placeholder": "Enter Policy Holder Name",
    "validation-maxlength": "200",
    "display-labelposition": "top",
    "display-disabled": 1,
  },
  "1717412387761-customDate": {
    elementid: 1717412387761,
    elementtype: "customDate",
    "display-fieldlabel": "Policy Start Date",
    "display-required": 1,
    "database-label": "policy_start_date",
    "display-placeholder": "dd-mm-yyyy",
    "display-labelposition": "top",
    // allowFutureDates: 1,
  },
  "1717412387762-customSelect": {
    elementid: 1717412387762,
    elementtype: "customSelect",
    "display-fieldlabel": "Policy Tenure",
    "display-required": 0,
    "database-label": "policy_tenure",
    "data-datasource": "customvalues",
    "data-customvalue": [
      { value: "1", label: "1 Year" },
      { value: "2", label: "2 Years" },
      { value: "3", label: "3 Years" },
    ],
    "display-placeholder": "Select Tenure",
    "display-labelposition": "top",
  },
  "1717412274041-customDate": {
    elementid: 1717412274041,
    elementtype: "customDate",
    "display-fieldlabel": "Policy End Date",
    "display-required": 1,
    "database-label": "policy_end_date",
    "display-placeholder": "dd-mm-yyyy",
    "display-labelposition": "top",
    // allowFutureDates: 1,
    // "display-disabled": 1,
  },
  "1717412412343-customDate": {
    elementid: 1717412412343,
    elementtype: "customDate",
    "display-fieldlabel": "Retroactive Date",
    "display-required": 0,
    "database-label": "retro_active_date",
    "display-placeholder": "dd-mm-yyyy",
    "display-labelposition": "top",
    // allowFutureDates: 1,
  },
  "1717412322777-customDate": {
    elementid: 1717412322777,
    elementtype: "customDate",
    "display-fieldlabel": "Issue Date",
    "display-required": 1,
    "database-label": "issue_date",
    "display-placeholder": "dd-mm-yyyy",
    "display-labelposition": "top",
    // allowFutureDates: 1,
  },
  "17174124127771-customDate": {
    elementid: 17174124127771,
    elementtype: "customDate",
    "display-fieldlabel": "Upload Date",
    // "display-required": 1,
    "database-label": "upload_date",
    // "database-label": "created_date",
    "display-placeholder": "dd-mm-yyyy",
    "display-labelposition": "top",
    "display-disabled": 1,
    // allowFutureDates: 1,
  },
  "17174124127779-customDate": {
    elementid: 17174124127779,
    elementtype: "customDate",
    "display-fieldlabel": "Policy Received date",
    // "display-required": 1,
    "database-label": "policy_received_date",
    "display-placeholder": "dd-mm-yyyy",
    "display-labelposition": "top",
    // allowFutureDates: 1,
  },
  "17174124127782-customDate": {
    elementid: 17174124127782,
    elementtype: "customDate",
    "display-fieldlabel": "Modified Date",
    "database-label": "modified_date",
    "display-placeholder": "dd-mm-yyyy",
    "display-labelposition": "top",
    "display-disabled": 1,
  },
  "1717412322677-textfield": {
    elementid: 1717412322677,
    elementtype: "textfield",
    "display-fieldlabel": "Premium Insurer",
    "display-required": 0,
    "database-label": "premium",
    "display-placeholder": "Enter Premium Insurer",
    "validation-maxlength": "200",
    "display-labelposition": "top",
    "display-disabled": 1,
  },
  "1717412351926-textarea": {
    elementid: 1717412351926,
    elementtype: "textarea",
    "display-fieldlabel": "Rejection Summary",
    "database-label": "rejection_summary",
    "display-placeholder": "Enter Rejection Summary",
    "validation-maxlength": "500",
    "display-labelposition": "top",
  },
  "1717412405878-file": {
    elementid: 1717412405878,
    elementtype: "file",
    "display-fieldlabel": "Policy Copy",
    "display-required": 1,
    "database-label": "policycopy_media_id",
    "display-labelposition": "top",
  },
  "1717412292824-documentFile": {
    elementid: 1717412292824,
    elementtype: "documentFile",
    "display-fieldlabel": "Application Form",
    "display-required": 0,
    "database-label": "applicationform_media_id",
    "display-labelposition": "top",
  },
};


export const PolicyDocumentsFieldsJSON = {
  "1717412405877-documentFile": {
    elementid: 1717412405877,
    elementtype: "documentFile",
    "display-fieldlabel": "Policy Copy",
    "display-required": 0,
    "database-label": "policycopy_media_id",
    "display-labelposition": "top",
  },
  "1717412292824-documentFile": {
    elementid: 1717412292824,
    elementtype: "documentFile",
    "display-fieldlabel": "Application Form",
    "display-required": 0,
    "database-label": "applicationform_media_id",
    "display-labelposition": "top",
  },
};
